export default __webpack_public_path__ + "static/media/eco-friendly.3261362e.png";